/**
 * Assets that a given entity is defined and throws an appropriate error if the entity is undefined.
 */
export function assertIsEntityDefined(entity, entityId, entityName) {
    if (!entity) {
        throw new Error(`Cannot find ${entityName} with ID: '${entityId}'.`);
    }
}
//# sourceMappingURL=assert-is-entity-defined.js.map